export const ItenTypes = {
  PROJECT: 'project',
  GROUP: 'group',
  INDIVIDUAL_TASK: 'individualTask',
  PHASE: 'phase',
  TASK: 'task',
};
